"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var ConsoleTransport_1 = require("../transports/ConsoleTransport");
var NoTransport_1 = require("../transports/NoTransport");
/**
 * the framework provides an abstract class Logger that needs to be extended
 */
var Logger = /** @class */ (function () {
    function Logger() {
        /**
         * if false, console log will be done for every log of the logger
         * if true, no console log for any log of the logger
         */
        this.noConsole = false;
        /**
         * The instance of transport that will send/log the events.
         * by default it will be ConsoleTransport
         */
        this.transport = new ConsoleTransport_1.ConsoleTransport();
        /**
         * if false, events will be triggered for that logger
         * if true, events will get disabled
         */
        this.isDisabled = false;
    }
    /**
     * method will be useful when we wanted to change the transport
     * @param transport
     */
    Logger.prototype.setTransport = function (transport) {
        if (this.isDisabled === false)
            this.transport = transport;
        else
            this.transport = new NoTransport_1.NoTransport();
    };
    Logger.prototype.setQueueName = function (queueName) {
        throw new Error('Method not implemented.');
    };
    return Logger;
}());
exports.Logger = Logger;
